import * as dates from '@simplybenefits/sb-dates';
import React, { PureComponent } from 'react';
import Text from '../../../components/Text.js';
import { colors } from '../../../theme/index.js';
import { helpers } from "@simplybenefits/sb-utils";
import zIndex from '../../../theme/zIndex.js';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TerminationModal from './TerminationModal.js';
import * as Services from '../../../services/index.js';
import i18n from '../../../localization/i18n.js';
import tokens from '../../../localization/tokens.js';
class PurchasedProducts extends PureComponent {
  state = {
    anchorEl: null,
    productToTerminate: null,
    showTerminationModal: false,
    total: 0
  };

  /**
   * @param event
   * @param productID
   * @param parentProductID
   * @param entity
   * @private
   */
  _handleMenuClick = (event, productID, parentProductID, entity) => {
    this.setState({
      anchorEl: event.currentTarget,
      productToTerminate: {
        productID,
        parentProductID
      }
    });
  };
  _handleCloseMenu = () => {
    this.setState({
      anchorEl: null
    });
  };
  _openTerminationModal = () => {
    this.setState({
      showTerminationModal: true,
      anchorEl: null
    });
  };
  _closeTerminationModal = () => {
    this.setState({
      showTerminationModal: false,
      productToTerminate: null
    });
  };

  /**
   * @param signage
   * @param password
   * @returns {Promise<boolean>}
   * @private
   */
  _terminateProduct = async (signage, password) => {
    const success = await this.props.terminateProduct(this.state.productToTerminate.productID, {
      ...signage,
      datedOn: Services.dates.formatOutgoingDate(signage.datedOn)
    }, password);
    if (success) {
      this._closeTerminationModal();
    }
    return false;
  };
  _getTotal = () => {
    let total = 0;

    // eslint-disable-next-line array-callback-return
    Object.keys(this.props.purchasedProducts).map(productID => {
      const product = this.props.purchasedProducts[productID];
      total += product.primary.premium + product.primary.PST + (product.primary.RST || 0) + product.primary.GST + product.primary.HST;
      total += product.dependent ? product.dependent.premium + product.dependent.PST + (product.dependent.RST || 0) + product.dependent.GST + product.dependent.HST : 0;
      total += product.spouse ? product.spouse.premium + product.spouse.PST + (product.spouse.RST || 0) + product.spouse.GST + product.spouse.HST : 0;
      total += product.child ? product.child.premium + product.child.PST + product.child.RST + product.child.GST + product.child.HST : 0;
    });
    return total;
  };
  _renderRow = (styles, product, member) => /*#__PURE__*/React.createElement("div", {
    style: styles.blockContent
  }, /*#__PURE__*/React.createElement(Text, {
    large: true,
    bold: true,
    color: this.props.whitelabel.primaryColor || colors.skyBlue,
    customStyle: {
      flex: 4
    }
  }, `${product.meta.type.toUpperCase() === 'VOLUNTARY' ? i18n.t(tokens.labels.marketplace.voluntary) : i18n.t(tokens.labels.marketplace.optional)} ${product.meta.name.primary[this.props.member.language]}`), product.meta.enBrochure && this.props.member.language === 'en' && /*#__PURE__*/React.createElement(Text, {
    tiny: true,
    color: this.props.whitelabel.primaryColor || colors.skyBlue,
    onClick: () => window.open(product.meta.enBrochure, "_blank"),
    customStyle: {
      cursor: 'pointer',
      marginLeft: 2,
      marginTop: -5
    }
  }, i18n.t(tokens.labels.marketplace.downloadBrochure)), product.meta.frBrochure && this.props.member.language === 'fr' && /*#__PURE__*/React.createElement(Text, {
    tiny: true,
    color: this.props.whitelabel.primaryColor || colors.skyBlue,
    onClick: () => window.open(product.meta.frBrochure, "_blank"),
    customStyle: {
      cursor: 'pointer',
      marginLeft: 2,
      marginTop: -5
    }
  }, i18n.t(tokens.labels.marketplace.downloadBrochure)), product.primary.active && /*#__PURE__*/React.createElement("div", {
    style: styles.blockRow
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 3,
      paddingLeft: 10
    }
  }, /*#__PURE__*/React.createElement(Text, {
    mediumLarge: true
  }, `${member.firstname} ${member.lastname}`), product.primary.termDate && /*#__PURE__*/React.createElement(Text, {
    tiny: true,
    color: "red"
  }, i18n.t(tokens.labels.marketplace.terminateOnDate, {
    termDate: dates.formatDateForDisplay(product.primary.termDate, "ll", i18n.locale)
  }))), product.meta.policyNumbers ? /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.inline
  }, /*#__PURE__*/React.createElement(Text, {
    small: true,
    align: "center",
    margin: "0 5px 0 0"
  }, i18n.t(tokens.labels.claimSummary.primary), ":"), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    align: "center"
  }, product.meta.primaryPolicyNumber || '-')), product.meta.policyNumbers.secondary && /*#__PURE__*/React.createElement("div", {
    style: styles.inline
  }, /*#__PURE__*/React.createElement(Text, {
    small: true,
    align: "center",
    margin: "0 5px 0 0"
  }, product.meta.policyNumbers.secondary.label[this.props.member.language], ":"), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    align: "center"
  }, product.meta.secondaryPolicyNumber || '-'))) : /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 2
    }
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    align: "center"
  }, "-")), product.meta.coverageSummary ? /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.inline
  }, /*#__PURE__*/React.createElement(Text, {
    small: true,
    color: this.props.whitelabel.primaryColor || colors.skyBlue,
    onClick: () => window.open(product.meta.coverageSummary.primary.link, "_blank"),
    customStyle: {
      flex: 1,
      cursor: 'pointer'
    },
    align: "center"
  }, product.meta.coverageSummary.primary.label[this.props.member.language])), product.meta.coverageSummary.secondary && /*#__PURE__*/React.createElement("div", {
    style: styles.inline
  }, /*#__PURE__*/React.createElement(Text, {
    small: true,
    color: this.props.whitelabel.primaryColor || colors.skyBlue,
    onClick: () => window.open(product.meta.coverageSummary.secondary.link, "_blank"),
    customStyle: {
      flex: 1,
      cursor: 'pointer'
    },
    align: "center"
  }, product.meta.coverageSummary.secondary.label[this.props.member.language]))) : /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 2
    },
    align: "center"
  }, product.meta.pricingType === 'static' ? '-' : i18n.t(tokens.labels.marketplace.pricingInCoverage, {
    pricing: helpers.formatNumber(product.primary.volume, 2, true)
  })), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    },
    align: "center"
  }, `${helpers.formatNumber(product.primary.premium + product.primary.PST + (product.primary.RST || 0) + product.primary.GST + product.primary.HST, 2, true)}${i18n.t(tokens.labels.marketplace.perMonth)}`), /*#__PURE__*/React.createElement("span", {
    style: styles.iconBlock
  }, /*#__PURE__*/React.createElement(MoreVertIcon, {
    style: styles.moreIcon,
    onClick: e => this._handleMenuClick(e, product.primary.productID, null, 'primary')
  }))), product.dependent && /*#__PURE__*/React.createElement("div", {
    style: styles.blockRow
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 3,
      paddingLeft: 10
    }
  }, /*#__PURE__*/React.createElement(Text, {
    mediumLarge: true
  }, i18n.t(tokens.labels.marketplace.dependentCoverage)), product.dependent.termDate && /*#__PURE__*/React.createElement(Text, {
    tiny: true,
    color: "red"
  }, i18n.t(tokens.labels.marketplace.terminateOnDate, {
    termDate: dates.formatDateForDisplay(product.dependent.termDate)
  }))), product.meta.policyNumbers ? /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.inline
  }, /*#__PURE__*/React.createElement(Text, {
    small: true,
    align: "center",
    margin: "0 5px 0 0"
  }, i18n.t(tokens.labels.claimSummary.primary), ":"), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    align: "center"
  }, product.meta.primaryPolicyNumber || '-')), product.meta.policyNumbers.secondary && /*#__PURE__*/React.createElement("div", {
    style: styles.inline
  }, /*#__PURE__*/React.createElement(Text, {
    small: true,
    align: "center",
    margin: "0 5px 0 0"
  }, product.meta.policyNumbers.secondary.label[this.props.member.language], ":"), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    align: "center"
  }, product.meta.secondaryPolicyNumber))) : /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 2
    }
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    align: "center"
  }, "-")), product.meta.coverageSummary ? /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.inline
  }, /*#__PURE__*/React.createElement(Text, {
    small: true,
    color: this.props.whitelabel.primaryColor || colors.skyBlue,
    onClick: () => window.open(product.meta.coverageSummary.primary.link, "_blank"),
    customStyle: {
      flex: 1,
      cursor: 'pointer'
    },
    align: "center"
  }, product.meta.coverageSummary.primary.label[this.props.member.language])), product.meta.coverageSummary.secondary && /*#__PURE__*/React.createElement("div", {
    style: styles.inline
  }, /*#__PURE__*/React.createElement(Text, {
    small: true,
    color: this.props.whitelabel.primaryColor || colors.skyBlue,
    onClick: () => window.open(product.meta.coverageSummary.secondary.link, "_blank"),
    customStyle: {
      flex: 1,
      cursor: 'pointer'
    },
    align: "center"
  }, product.meta.coverageSummary.secondary.label[this.props.member.language]))) : /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 2
    },
    align: "center"
  }, product.meta.pricingType === 'static' ? '-' : i18n.t(tokens.labels.marketplace.pricingInCoverage, {
    pricing: helpers.formatNumber(product.dependent.volume, 2, true)
  })), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    },
    align: "center"
  }, `${helpers.formatNumber(product.dependent.premium + product.dependent.PST + (product.dependent.RST || 0) + product.dependent.GST + product.dependent.HST, 2, true)}${i18n.t(tokens.labels.marketplace.perMonth)}`), /*#__PURE__*/React.createElement("span", {
    style: styles.iconBlock
  }, /*#__PURE__*/React.createElement(MoreVertIcon, {
    style: styles.moreIcon,
    onClick: e => this._handleMenuClick(e, product.dependent.productID, product.primary.productID, 'primary')
  }))), product.spouse && /*#__PURE__*/React.createElement("div", {
    style: styles.blockRow
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 3,
      paddingLeft: 10
    }
  }, /*#__PURE__*/React.createElement(Text, {
    mediumLarge: true
  }, i18n.t(tokens.labels.marketplace.spouseCoverage)), product.spouse.termDate && /*#__PURE__*/React.createElement(Text, {
    tiny: true,
    color: "red"
  }, i18n.t(tokens.labels.marketplace.terminateOnDate, {
    termDate: dates.formatDateForDisplay(product.spouse.termDate)
  }))), product.meta.policyNumbers ? /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.inline
  }, /*#__PURE__*/React.createElement(Text, {
    small: true,
    align: "center",
    margin: "0 5px 0 0"
  }, i18n.t(tokens.labels.claimSummary.primary), ":"), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    align: "center"
  }, product.meta.primaryPolicyNumber || '-')), product.meta.policyNumbers.secondary && /*#__PURE__*/React.createElement("div", {
    style: styles.inline
  }, /*#__PURE__*/React.createElement(Text, {
    small: true,
    align: "center",
    margin: "0 5px 0 0"
  }, product.meta.policyNumbers.secondary.label[this.props.member.language], ":"), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    align: "center"
  }, product.meta.secondaryPolicyNumber))) : /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 2
    }
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    align: "center"
  }, "-")), product.meta.coverageSummary ? /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.inline
  }, /*#__PURE__*/React.createElement(Text, {
    small: true,
    color: this.props.whitelabel.primaryColor || colors.skyBlue,
    onClick: () => window.open(product.meta.coverageSummary.primary.link, "_blank"),
    customStyle: {
      flex: 1,
      cursor: 'pointer'
    },
    align: "center"
  }, product.meta.coverageSummary.primary.label[this.props.member.language])), product.meta.coverageSummary.secondary && /*#__PURE__*/React.createElement("div", {
    style: styles.inline
  }, /*#__PURE__*/React.createElement(Text, {
    small: true,
    color: this.props.whitelabel.primaryColor || colors.skyBlue,
    onClick: () => window.open(product.meta.coverageSummary.secondary.link, "_blank"),
    customStyle: {
      flex: 1,
      cursor: 'pointer'
    },
    align: "center"
  }, product.meta.coverageSummary.secondary.label[this.props.member.language]))) : /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 2
    },
    align: "center"
  }, product.meta.pricingType === 'static' ? '-' : i18n.t(tokens.labels.marketplace.pricingInCoverage, {
    pricing: helpers.formatNumber(product.spouse.volume, 2, true)
  })), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    },
    align: "center"
  }, `${helpers.formatNumber(product.spouse.premium + product.spouse.PST + (product.spouse.RST || 0) + product.spouse.GST + product.spouse.HST, 2, true)}${i18n.t(tokens.labels.marketplace.perMonth)}`), /*#__PURE__*/React.createElement("span", {
    style: styles.iconBlock
  }, /*#__PURE__*/React.createElement(MoreVertIcon, {
    style: styles.moreIcon,
    onClick: e => this._handleMenuClick(e, product.spouse.productID, product.primary.productID, 'primary')
  }))), product.child && /*#__PURE__*/React.createElement("div", {
    style: styles.blockRow
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 3,
      paddingLeft: 10
    }
  }, /*#__PURE__*/React.createElement(Text, {
    mediumLarge: true
  }, i18n.t(tokens.labels.marketplace.childCoverage)), product.child.termDate && /*#__PURE__*/React.createElement(Text, {
    tiny: true,
    color: "red"
  }, i18n.t(tokens.labels.marketplace.terminateOnDate, {
    termDate: dates.formatDateForDisplay(product.child.termDate)
  }))), product.meta.policyNumbers ? /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.inline
  }, /*#__PURE__*/React.createElement(Text, {
    small: true,
    align: "center",
    margin: "0 5px 0 0"
  }, i18n.t(tokens.labels.claimSummary.primary), ":"), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    align: "center"
  }, product.meta.primaryPolicyNumber || '-')), product.meta.policyNumbers.secondary && /*#__PURE__*/React.createElement("div", {
    style: styles.inline
  }, /*#__PURE__*/React.createElement(Text, {
    small: true,
    align: "center",
    margin: "0 5px 0 0"
  }, product.meta.policyNumbers.secondary.label[this.props.member.language], ":"), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    align: "center"
  }, product.meta.secondaryPolicyNumber))) : /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 2
    }
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    align: "center"
  }, "-")), product.meta.coverageSummary ? /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.inline
  }, /*#__PURE__*/React.createElement(Text, {
    small: true,
    color: this.props.whitelabel.primaryColor || colors.skyBlue,
    onClick: () => window.open(product.meta.coverageSummary.primary.link, "_blank"),
    customStyle: {
      flex: 1,
      cursor: 'pointer'
    },
    align: "center"
  }, product.meta.coverageSummary.primary.label[this.props.member.language])), product.meta.coverageSummary.secondary && /*#__PURE__*/React.createElement("div", {
    style: styles.inline
  }, /*#__PURE__*/React.createElement(Text, {
    small: true,
    color: this.props.whitelabel.primaryColor || colors.skyBlue,
    onClick: () => window.open(product.meta.coverageSummary.secondary.link, "_blank"),
    customStyle: {
      flex: 1,
      cursor: 'pointer'
    },
    align: "center"
  }, product.meta.coverageSummary.secondary.label[this.props.member.language]))) : /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 2
    },
    align: "center"
  }, product.meta.pricingType === 'static' ? '-' : i18n.t(tokens.labels.marketplace.pricingInCoverage, {
    pricing: helpers.formatNumber(product.child.volume, 2, true)
  })), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    },
    align: "center"
  }, `${helpers.formatNumber(product.child.premium + product.child.PST + (product.child.RST || 0) + product.child.GST + product.child.HST, 2, true)}${i18n.t(tokens.labels.marketplace.perMonth)}`), /*#__PURE__*/React.createElement("span", {
    style: styles.iconBlock
  }, /*#__PURE__*/React.createElement(MoreVertIcon, {
    style: styles.moreIcon,
    onClick: e => this._handleMenuClick(e, product.child.productID, product.primary.productID, 'primary')
  }))));
  render() {
    const styles = {
      container: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column'
      },
      titleBlock: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 10
      },
      block: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        border: `1px solid ${colors.lightGrey}`,
        backgroundColor: colors.surface,
        position: 'relative',
        zIndex: zIndex.container
      },
      blockTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: "20px 30px",
        borderBottom: `1px solid ${colors.lightGrey}`
      },
      blockContent: {
        display: 'flex',
        flexDirection: 'column',
        padding: "20px 30px",
        borderBottom: `1px solid ${colors.lightGrey}`
      },
      blockRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: "10px 0 0 0"
      },
      totalBlock: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: "20px 30px"
      },
      iconBlock: {
        textAlign: 'right',
        width: 20
      },
      moreIcon: {
        color: colors.darkGrey,
        cursor: 'pointer'
      },
      inline: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center'
      }
    };
    const purchasedProducts = Object.keys(this.props.purchasedProducts);
    let productNameToTerminate = null;
    let productToTerminate = null;
    if (this.state.showTerminationModal) {
      productToTerminate = this.props.purchasedProducts[this.state.productToTerminate.parentProductID || this.state.productToTerminate.productID].meta;
      if (productToTerminate.childProductType && productToTerminate.childProductType.toLowerCase() !== 'primary') {
        productNameToTerminate = productToTerminate.name[productToTerminate.childProductType.toLowerCase()];
      } else {
        productNameToTerminate = productToTerminate.name.primary;
      }
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      style: styles.titleBlock
    }, /*#__PURE__*/React.createElement(Text, {
      large: true,
      bold: true,
      margin: "0 0 10px 0"
    }, i18n.t(tokens.labels.marketplace.yourProducts))), purchasedProducts.length === 0 ? /*#__PURE__*/React.createElement("div", {
      style: styles.block
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.blockTitle
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.marketplace.noProductsPurchased)))) : /*#__PURE__*/React.createElement("div", {
      style: styles.block
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.blockTitle
    }, /*#__PURE__*/React.createElement(Text, {
      mediumLarge: true,
      bold: true,
      customStyle: {
        flex: 3
      }
    }, i18n.t(tokens.labels.marketplace.marketplaceProduct)), /*#__PURE__*/React.createElement(Text, {
      mediumLarge: true,
      bold: true,
      customStyle: {
        flex: 2
      },
      align: "center"
    }, i18n.t(tokens.labels.marketplace.primaryPolicyNumber)), /*#__PURE__*/React.createElement(Text, {
      mediumLarge: true,
      bold: true,
      customStyle: {
        flex: 2
      },
      align: "center"
    }, i18n.t(tokens.labels.marketplace.coverage)), /*#__PURE__*/React.createElement(Text, {
      mediumLarge: true,
      bold: true,
      align: "center",
      customStyle: {
        flex: 1
      }
    }, i18n.t(tokens.labels.marketplace.monthlyFee)), /*#__PURE__*/React.createElement("span", {
      style: styles.iconBlock
    })), purchasedProducts.length > 0 && purchasedProducts.map(productID => {
      const product = this.props.purchasedProducts[productID];
      return this._renderRow(styles, product, this.props.member);
    }), /*#__PURE__*/React.createElement("div", {
      style: styles.totalBlock
    }, /*#__PURE__*/React.createElement(Text, {
      large: true,
      bold: true,
      customStyle: {
        flex: 1
      }
    }, i18n.t(tokens.labels.total)), /*#__PURE__*/React.createElement(Text, {
      large: true,
      bold: true
    }, helpers.formatNumber(this._getTotal(), 2, true)), /*#__PURE__*/React.createElement(Text, {
      medium: true,
      customStyle: {
        marginTop: 5
      }
    }, i18n.t(tokens.labels.marketplace.perMonth))), this.state.showTerminationModal && /*#__PURE__*/React.createElement(TerminationModal, {
      close: this._closeTerminationModal,
      save: this._terminateProduct,
      loading: this.props.loading,
      isMasterSite: this.props.isMasterSite,
      whitelabel: this.props.whitelabel,
      productToTerminate: productToTerminate,
      member: this.props.member
    }), /*#__PURE__*/React.createElement(Menu, {
      anchorEl: this.state.anchorEl,
      open: this.state.anchorEl !== null,
      onClose: this._handleCloseMenu,
      disableAutoFocusItem: true,
      sx: {
        '& .MuiPaper-root': {
          borderRadius: '8px',
          minWidth: 250
        }
      },
      anchorOrigin: {
        vertical: "top",
        horizontal: "left"
      }
    }, /*#__PURE__*/React.createElement(MenuItem, {
      style: styles.navDropMenuItem,
      onClick: this._openTerminationModal
    }, /*#__PURE__*/React.createElement(Text, {
      align: "center",
      medium: true,
      display: "block",
      customLinkStyle: {
        textDecoration: 'none'
      }
    }, i18n.t(tokens.labels.marketplace.terminateCoverage))))));
  }
}
export default PurchasedProducts;